<script setup lang="ts">

import {useAvatar} from "@/composables/avatar";
import {ExtendedProject} from "@/types";
import {router} from "@inertiajs/vue3";
import {useDate} from "@/composables/date";

interface Props {
    project: ExtendedProject
}

const props = defineProps<Props>()

const { shortDate } = useDate()

const goToProject = () => {
    router.visit(route('projects.show', {project: props.project.slug}))
}
</script>

<template>
    <v-list-item
        border="sm"
        rounded="lg"
        min-height="76"
        class="mb-5"
        lines="three"
    >
        <template #prepend>
            <v-avatar
                size="36"
                class="border-sm"
            >
                <img
                    :src="useAvatar(props.project.name)"
                    alt="avatar"
                >
            </v-avatar>
        </template>
        <v-list-item-title>
            <div class="text-primary font-weight-medium">
                <span
                    class="hover-underline mr-1"
                    @click="goToProject"
                >{{ props.project.name }}</span>
                <v-chip
                    variant="outlined"
                    size="x-small"
                    class="text-caption font-weight-bold px-2 ml-1"
                    color="grey-lighten-1"
                >
                    <span class="text-grey-darken-1">{{ props.project.is_public ? 'Public' : 'Private' }}</span>
                </v-chip>
            </div>
        </v-list-item-title>
        <div
            v-if="props.project.description"
            class="text-body-2 text-black mt-1 mb-2"
        >
            {{ props.project.description }}
        </div>
        <v-list-item-subtitle
            class="text-caption mt-1"
        >
            <v-icon class="mb-1">
                mdi-account-multiple-outline
            </v-icon>
            {{ props.project.users_count }}
            <v-icon class="ml-2 mb-1">
                mdi-cloud-upload-outline
            </v-icon>
            {{ props.project.uploads_count }}
            <span class="ml-3">Updated on {{ shortDate(props.project.updated_at) }}</span>
        </v-list-item-subtitle>
    </v-list-item>
</template>

<style scoped>
.hover-underline:hover {
    text-decoration: underline;
    text-decoration-color: #1976d2 !important;
    cursor: pointer;
}
</style>
